import React, { Component } from 'react';
import ContentLayoutComponent from './ContentLayout'

class Layout extends Component {
  render() { return <ContentLayoutComponent /> }
}

export default Layout;
